import { NumberInput } from "@mantine/core";

export const numberInputComponentSettings = NumberInput.extend({
  defaultProps: {
    thousandSeparator: true,
  },
});
